import IconService from '../../services/IconService';

export default {
    state: {
        collection: {},
    },
    getters: {
        getAllIcons: store => store.collection,
        getAllStatusIcons: store => Object.keys(store.collection).filter(key => store.collection[key].isStatus === true).map(key => store.collection[key]),
    },
    mutations: {
        loadIcons(state, payload) {
            state.collection = payload;
        },
    },
    actions: {
        async loadIcons(context) {
            try {
                const payload = await IconService.getAll();
                context.commit('loadIcons', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
    },
    namespaced: true,
};
